import { type LandingContentsCityCardsInner } from '@clients/ContentApi';
import { toAbsoluteSrc } from '@store/content';

export class CityCard {
    constructor(data: LandingContentsCityCardsInner) {
        this.id = data.id;
        this.cityTitle = data.CityTitle ?? '';
        this.link = data.Link ?? '';
        this.image = toAbsoluteSrc(data.Image?.url);
        this.imageAlt = data.ImageAlt ?? '';
    }

    id: string;
    cityTitle: string;
    link: string;
    image: string;
    imageAlt: string;

    toJSON() {
        return { ...this };
    }
}
